import {
  GET_EVENT_CREW,
  UPDATE_EVENT_ROLE,
  DELETE_EVENT_ROLE,
  UPDATE_AVAILABLE_TOOLS
} from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${GET_EVENT_CREW}_SUCCESS`) {
    return action.payload;
  }

  if (action.type === DELETE_EVENT_ROLE) {
    const {
      payload: { userId }
    } = action;

    const modifiedState = state.filter(user => {
      return user._id !== userId;
    });

    return [...modifiedState];
  }

  if (action.type === UPDATE_EVENT_ROLE) {
    const {
      payload: { userId, newRoleValue, roleId }
    } = action;

    const modifiedState = state.map(user => {
      if (user._id !== userId) return user;
      user.events = user.events.map(roleObj => {
        if (roleObj._id !== roleId) return roleObj;
        roleObj.role = newRoleValue;
        return roleObj;
      });
      return user;
    });

    return [...modifiedState];
  }

  if (action.type === `${UPDATE_AVAILABLE_TOOLS}_SUCCESS`) {
    const {
      payload: { userId, availableTools, eventId }
    } = action;

    const modifiedState = state.map(user => {
      if (user._id !== userId) return user;

      user.events = user.events.map(roleObj => {
        if (roleObj.event !== eventId) return roleObj;
        roleObj.availableTools = availableTools;
        return roleObj;
      });
      return user;
    });

    return [...modifiedState];
  }

  return state;
};
